import { createSlice } from "@reduxjs/toolkit";

const ScanPrintslice = createSlice({
  name: "scan",
  initialState: {
    ScanPrintStatsToggleStatus: "Scan Barcode",
    WarehouseStatsToggleStatus: "General",

  },
  reducers: {
   

    setScanPrintToggleStatus(state, action) {
        state.ScanPrintStatsToggleStatus = action.payload;
      },
      setWarehouseStatsToggleStatus(state, action) {
        state.WarehouseStatsToggleStatus = action.payload;
      },
  },
});

export const {
  
  setScanPrintToggleStatus,
  setWarehouseStatsToggleStatus,

} = ScanPrintslice.actions;

export default ScanPrintslice.reducer;
